module.exports = __webpack_public_path__ + "img/nav_b2_pic4.4adeb06b.png";